const dsn = 'https://df219a0bd25541408bb762d55d2c88af@sentry.airtel.in/sentryb2b/2';

const release = 'dedicated-internet-ui@1.0.0';

const ignoreErrors = [
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage',
  // Generic error code from errors outside the security sandbox
  // You can delete this if using raven.js > 1.0, which ignores these automatically.
  'Script error.',
  'InvalidStateError: A mutation operation was attempted on a database that did not allow mutations.',
  'Request failed with status code 401',
  /chunk [\d]+ failed/,
  'VersionError: An attempt was made to open a database using a lower version than the existing version.',
  'QuotaExceededError',
  'AbortError: The operation was aborted.',
  'NetworkError when attempting to fetch resource.',
  'UnknownError: Internal error opening backing store for indexedDB.open.',
  'Illegal invocation',
  '[object SQLError]',
  'AbortError: The transaction was aborted, so the request cannot be fulfilled.',
  'UnknownError: Connection is closing.',
  'UnknownError: Attempt to delete range from database without an in-progress transaction',
  'ResizeObserver loop limit exceeded',
  'ReferenceError: privateSpecialRepair is not defined',
  'TimeoutError: Transaction timed out due to inactivity.',
  'Non-Error exception captured',
  'Non-Error promise rejection captured',
  'onHwBackPressed is not defined',
  'showCastButtonOnWebPage is not defined',
  "NotFoundError: Failed to execute 'transaction' on 'IDBDatabase'",
  'Error: Request aborted',
  'Error: Network Error',
  'Error: timeout of 0ms exceeded',
  "Cannot read properties of null (reading 'CodeMirror')",
  'ResizeObserver loop completed with undelivered notifications.'
];

const ignoreUrls = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
];

export const SENTRY_OPTIONS = {
  dsn,
  release,
  ignoreErrors,
  ignoreUrls
};

export const SENTRY_ERROR = {
  FETCH_ABORT: 'Abort error',
  ENV_CONFIG_LOAD: 'Failed to fetch environment config',
  PAGE_NOT_FOUND: '404 Page not found',
  API_ERROR: 'Unknown API error occured'
};

export const LOGLEVEL = {
  fatal: 'fatal',
  critical: 'critical',
  error: 'error',
  warning: 'warning',
  log: 'log',
  info: 'info',
  debug: 'debug'
};
